define([
	"dojo/_base/declare",
	"csi/html",
	"csi/middleware/customView/customViewDataManagementService",
	"./String"
], function(declare,html,{stringNonTextFormatOperators}, StringRen) {

	return declare(StringRen, {
		queryOps: stringNonTextFormatOperators,

		canLink: function() {
			// summary: email strings are already anchors
			return false;
		},

		/**
		 * @override
		 * allow filter in custom view to select from existing values
		 */
		getQuerySpec: function(ctx, h, spec) {
			var	qs = this.inherited(arguments);
			qs.allowFilteringBySelectionOfExistingValues = true;
			return qs;
		},

		_toHtmlString: function(/*String*/value, /*DOMNode*/refNode, /*Boolean*/bCanLink) {
			// summary: create mailto link
			if (bCanLink) {
				refNode = html.a({
					href: "mailto:" + value, 
					onclick: html.stopPropagation
				}, refNode);
			}

			this.inherited(arguments, [value, refNode, bCanLink]);
		}
	});
});